'use strict';

import {
    addSelectedCompanyHandler,
    companyGuard,
    getSelectedCompanyForUser,
    pjaxRedirect
} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnCreateNewEmployee = function () {

    var element = '#btn-create-employee';

    if (!element_exists(element)) return false;


    var btnCreateEmployee = $(element);

    toggleBtn();

    btnCreateEmployee.off('click').on('click', function () {
        if (!companyGuard()) {
            pjaxRedirect(
                '/employees/new/' + getSelectedCompanyForUser()
            );
        }
    });

    function toggleBtn() {
        if (companyGuard()) {
            btnCreateEmployee.parent().addClass('hidden');
        } else {
            btnCreateEmployee.parent().removeClass('hidden');

        }
    }

    addSelectedCompanyHandler(function () {

        toggleBtn();
    });
};
